import { React, useCallback, useState } from "react";
import classes from "./Sidebar.module.css";
import PersonIcon from "@mui/icons-material/Person";
import PersonOutlineIcon from "@mui/icons-material/PersonOutlineOutlined";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import AppRegistrationOutlinedIcon from "@mui/icons-material/AppRegistrationOutlined";
import { useNavigate } from "react-router-dom";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import FolderSharedOutlinedIcon from "@mui/icons-material/FolderSharedOutlined";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import ArticleIcon from "@mui/icons-material/Article";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import Tooltip from "@mui/material/Tooltip";
import TtecLogo from "assets/images/ttecLogo.png";
import ObtMgmtDrawer from "./ObtMgmtDrawer";
import PropTypes from "prop-types";
import { Button, IconButton } from "@mui/material";
import AsttDrawer from "./AsttDrawer";
import SaveIcon from "@mui/icons-material/Save";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import PieChartIcon from '@mui/icons-material/PieChart';
import PieChartOutlineOutlinedIcon from '@mui/icons-material/PieChartOutlineOutlined';
import InsightsIcon from "@mui/icons-material/Insights";

function Sidebar({ index, type, classRosterId }) {
  const navigate = useNavigate();
  const [hideToolTip, setHideToolTip] = useState(false);

  const dtrRedirection = useCallback(
    (classRosterId, dtrDate, isEditable) => {
      navigate("/learnpoint/infoSection/dtrDetails", {
        state: {
          classRosterId: classRosterId,
          dtrDate: dtrDate,
          isEditable: isEditable,
        },
      });
    },
    [navigate],
  );

  const learnpoint = [
    {
      title: "Framework",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/learnpoint/infoSection/frameworks`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 2 ? (
            <FolderSharedIcon className={classes.cpBlueIcon} />
          ) : (
            <FolderSharedOutlinedIcon className={classes.cpWhiteIcon} />
          )}
        </IconButton>
      ),
    },
    {
      title: "Merge ClassRoster",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            dtrRedirection(null, classRosterId, true);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 8 ? (
            <PersonIcon className={classes.cpBlueIcon} />
          ) : (
            <PersonOutlineIcon className={classes.cpWhiteIcon} />
          )}
        </IconButton>
      ),
    },
    {
      title: "Class Roster",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/learnpoint/infoSection/ClassRoster`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 7 ? (
            <SchoolRoundedIcon className={classes.cpBlueIcon} />
          ) : (
            <SchoolOutlinedIcon className={classes.cpWhiteIcon} />
          )}
        </IconButton>
      ),
    },
  ];

  const centerpoint = [
    {
      title: "Search Employee",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/centerpoint/searchEmployee`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 1 ? (
            <PersonIcon className={classes.cpBlueIcon} />
          ) : (
            <PersonOutlineIcon className={classes.cpWhiteIcon} />
          )}
        </IconButton>
      ),
    },
    {
      title: "Add Non HRMS Employee",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/centerpoint/addEmployee`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 2 ? (
            <PersonAddIcon className={classes.cpBlueIcon} />
          ) : (
            <PersonAddAltOutlinedIcon className={classes.cpWhiteIcon} />
          )}
        </IconButton>
      ),
    },
    {
      title: "Bulk Upload",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/centerpoint/bulkUpload`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 3 ? (
            <AppRegistrationIcon className={classes.cpBlueIcon} />
          ) : (
            <AppRegistrationOutlinedIcon className={classes.cpWhiteIcon} />
          )}
        </IconButton>
      ),
    },
    {
      title: "Audit Trails",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/centerpoint/auditTrails`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 5 ? (
            <ArticleIcon className={classes.cpBlueIcon} />
          ) : (
            <ArticleOutlinedIcon className={classes.cpWhiteIcon} />
          )}
        </IconButton>
      ),
    },
  ];

  const coreratio = [
    {
      title: "GOE",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/coreratio/goe`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 1 ? (
            <SaveIcon className={classes.cpBlueIcon} />
          ) : (
            <SaveOutlinedIcon className={classes.cpWhiteIcon} />
          )}
        </IconButton>
      ),
    },
  ];

  const biReport = [
    {
      title: "ASTT Analysis",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/biReport/summaryanalysis`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 1 ? (
            <PieChartIcon className={classes.cpBlueIcon} />
          ) : (
            <PieChartOutlineOutlinedIcon className={classes.cpWhiteIcon} />
          )}
        </IconButton>
      ),
    },
    {
      title: "Log Insights",
      icon: (
        <IconButton
          onClick={(e) => {
            setHideToolTip(true);
            navigate(`/biReport/loginsights`);
            e.currentTarget.blur();
            setTimeout(() => setHideToolTip(false), 1000);
          }}
          disableRipple
          disableFocusRipple
          sx={{ "&:hover": { backgroundColor: "transparent" } }}
        >
          {index === 2 ? (
            <InsightsIcon className={classes.cpBlueIcon} />
          ) : (
            <InsightsIcon className={classes.cpWhiteIcon} />
          )}
        </IconButton>
      ),
    },
  ];

  if (type === "centerpoint")
    return (
      <div className={classes.container}>
        <div className={classes.sidebar}>
          <Button
            className={classes.logoButton}
            onClick={() => {
              navigate(`/welcome`);
            }}
            aria-label="Centerpoint (Home)"
          >
            <img src={TtecLogo} className={classes.logo} alt={"Ttec Logo"} />
          </Button>
          {centerpoint.map((item, index) => (
            <Tooltip
              title={item.title}
              placement="right"
              key={item.title + index}
              arrow
              disableHoverListener={hideToolTip}
              disableFocusListener={hideToolTip}
            >
              {item.icon}
            </Tooltip>
          ))}
        </div>
      </div>
    );
  else if (type === "learnpoint")
    return (
      <div className={classes.container}>
        <div className={classes.sidebar}>
          <Button
            className={classes.logoButton}
            onClick={() => {
              navigate(`/welcome`);
            }}
            aria-label="Learnpoint (Home)"
          >
            <img src={TtecLogo} className={classes.logo} alt={"Ttec Logo"} />
          </Button>
          {learnpoint.map((item, index) => (
            <Tooltip
              title={item.title}
              placement="right"
              key={item.title + index}
            >
              {item.icon}
            </Tooltip>
          ))}
        </div>
      </div>
    );
  else if (type === "ObtMgmt") return <ObtMgmtDrawer index={index} />;
  else if (type === "AsttMgmt") return <AsttDrawer index={index} />;
  else if (type === "coreratio")
    return (
      <div className={classes.container}>
        <div className={classes.sidebar}>
          <Button
            className={classes.logoButton}
            onClick={() => {
              navigate(`/welcome`);
            }}
            aria-label="Core Ratio (Home)"
          >
            <img src={TtecLogo} className={classes.logo} alt={"Ttec Logo"} />
          </Button>
          {coreratio.map((item, index) => (
            <Tooltip
              title={item.title}
              placement="right"
              key={item.title + index}
              arrow
              disableHoverListener={hideToolTip}
              disableFocusListener={hideToolTip}
            >
              {item.icon}
            </Tooltip>
          ))}
        </div>
      </div>
    );
  else if (type === "bulkEditV2")
    return (
      <div className={classes.container}>
        <div className={classes.sidebar}>
          <Button
            className={classes.logoButton}
            onClick={() => {
              navigate(`/welcome`);
            }}
            aria-label="bulkEditV2"
          >
            <img src={TtecLogo} className={classes.logo} alt={"Ttec Logo"} />
          </Button>
        </div>
      </div>
    );
  else if (type === "biReport")
    return (
      <div className={classes.container}>
        <div className={classes.sidebar}>
          <Button
            className={classes.logoButton}
            onClick={() => {
              navigate(`/welcome`);
            }}
            aria-label="Report (Home)"
          >
            <img src={TtecLogo} className={classes.logo} alt={"Ttec Logo"} />
          </Button>
          {biReport.map((item, index) => (
            <Tooltip
              title={item.title}
              placement="right"
              key={item.title + index}
              arrow
              disableHoverListener={hideToolTip}
              disableFocusListener={hideToolTip}
            >
              {item.icon}
            </Tooltip>
          ))}
        </div>
      </div>
    );
  else
    return (
      <div className={classes.container}>
        <div className={classes.sidebar}>
          <img src={TtecLogo} className={classes.logo} alt="Ttec logo" />
        </div>
      </div>
    );
}

Sidebar.propTypes = {
  index: PropTypes.number,
  type: PropTypes.string,
  classRosterId: PropTypes.number,
};

export default Sidebar;
